<template>
    <div class="FilterList"
         v-click-outside="closePopup">
        <div class="FilterList--button"
             :style="{ height, width }"
             @click="togglePopup"
        >
            <span>{{label}}</span>
            <i class="material-icons">
                arrow_drop_down
            </i>
        </div>
        <template v-if="isPopupOpen">
            <div class="FilterList--list">
                <checkbox class="FilterList--list-checkbox"
                          v-for="option of dataList"
                          :key="option.id"
                          :checkbox-id="option.id"
                          :checked="option.checked"
                          @update:checked="onChecked(option.title, $event)"
                >
                    {{ option.title }}
                </checkbox>
            </div>
        </template>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {
        name: 'FilterList',

        components: {
            Checkbox: () => import('@/components/controls/Checkbox')
        },

        data() {
            return {
                isPopupOpen: false
            }
        },

        props: {
            dataList: {
                type: Array,
                required: true
            },
            label: {
                type: String,
                required: true
            },
            height: {
                type: String,
                required: false,
                default: '40px'
            },
            width: {
                type: String,
                required: false,
                default: '155px'
            }
        },

        directives: { ClickOutside },

        methods: {
            togglePopup() {
                this.isPopupOpen = !this.isPopupOpen;
            },

            closePopup() {
                if (this.isPopupOpen) {
                    this.isPopupOpen = false;
                }
            },

            onChecked(option, checked) {
                this.$emit('update:checked', { option, checked });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/styles/variables/colors';

    .FilterList {
        position: relative;
        width: 100%;

        &--button {
            position: relative;
            min-width: 120px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 16px;
            border-radius: 4px;
            border: 2px solid $ComplementaryBgTxtDarker;
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
            color: $Dark;
            background-color: $White;

            @media screen and (max-width: 425px) {
                width: 140px !important;
            }

            i {
                color: $GreySecondary;
            }
        }

        &--list {
            z-index: 10;
            position: absolute;
            top: 50px;
            width: 100%;
            min-width: 150px;
            max-height: 250px;
            padding: 20px;
            border-radius: 4px;
            box-shadow: 0 0 20px 0 rgba(176, 186, 197, 0.25);
            overflow-y: auto;
            font-size: 14px;
            background: $White;

            &::-webkit-scrollbar {
                width: 8px;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 4px;
                background-color: $GreySecondary;
            }

            &-checkbox {
                margin-bottom: 19px;
                color: $Dark;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/controls/FilterList.vue